<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="ncms"
        :headers="headers"
        :rotina-id="ID_TELA_DE_NCM"
        :configurar="false"
        :loading="loading"
        :sort-by="'codigo'"
        :busca-param="buscaParam"
        @create="() => abrirDialogCriarNCM()"
        @update="(indice) => abrirDialogEditarNCM(indice)"
        @delete="(indice) => openDialogDeleteNCM(indice)"
      >
        <template #[`item.dataInicio`]="{ item }">
          {{ formatDate(item.dataInicio) }}
        </template>

        <template #[`item.dataFim`]="{ item }">
          {{ formatDate(item.dataFim) }}
        </template>
      </DataTableDeCrud>

      <DialogDeEdicaoDeNCM
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :ncm-param="ncmParam"
        :itens="itensParam"
        @confirmado="atualizarNCM"
      />

      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogDeleteNCM" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="ncmDelete">
            Tem certeza que deseja excluir o NCM <b> {{ ncmDelete.descricao }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogDeleteNCM = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="removerNCM">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import NCMService from '../../../services/ncm/ncm'
import SnackbarMessage from '../../../components/SnackbarMessage'
import DialogDeEdicaoDeNCM from '../../../components/ncms/DialogDeEdicaoDeNCM'
import DataTableDeCrud from '../../../components/DataTableDeCrud'
import SnackBar from '../../../models/components/snackbar'
import NCM from '../../../models/ncm'
import { ID_TELA_DE_NCM } from '@/common/constants'
import { formatDate } from '@/shareds/formatacoes'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeNCM
  },
  data: () => ({
    name: 'TelaDeNCM',
    headers: [
      { text: 'Código', value: 'codigo', width: '10%' },
      { text: 'Descrição', value: 'descricao', width: '70%' },
      { text: 'Início', value: 'dataInicio' },
      { text: 'Fim', value: 'dataFim' }
    ],
    ncms: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    ncmParam: new NCM(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogDeleteNCM: false,
    ncmDelete: new NCM(),
    indiceNCMDelete: 0,
    ID_TELA_DE_NCM: ID_TELA_DE_NCM,
    formatDate: formatDate
  }),

  computed: {
    buscaParam() {
      return this.$route.query.codigo
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        if (this.$route.query.id) {
          NCMService.getById(this.$route.query.id).then((response) => this.ncms.push(response))
        } else {
          this.loadNCMs()
        }
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar NCMs cadastrados.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadNCMs() {
      this.loading = true
      const response = await NCMService.getAll()
      this.ncms = response.map((item) => ({
        ...item
      }))
      this.loading = false
    },

    atualizarNCM(ncm) {
      if (!ncm) return

      const indice = this.ncms.findIndex((ncmExistente) => ncmExistente.id === ncm.id)

      if (indice === -1) {
        this.ncms.push(ncm)
        this.snackbar.snackTextParam = 'NCM criado com sucesso.'
      } else {
        this.ncms.splice(indice, 1, ncm)
        this.snackbar.snackTextParam = 'NCM atualizado com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    openDialogDeleteNCM(indice) {
      this.ncmDelete = this.ncms[indice]
      if (!this.ncmDelete.id) return

      this.indiceNCMDelete = indice
      this.dialogDeleteNCM = true
    },

    async removerNCM() {
      try {
        await NCMService.deleteById(this.ncmDelete.id)
        this.snackbar.snackTextParam = 'NCM removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.ncms.splice(this.indiceNCMDelete, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogDeleteNCM = false
    },

    abrirDialogCriarNCM() {
      this.operacao = 'adicionar'
      this.itensParam = {}
      this.ncmParam = new NCM()
      this.showDialogParam = true
    },

    abrirDialogEditarNCM(indice) {
      this.operacao = 'editar'
      this.itensParam = {}
      this.ncmParam = { ...this.ncms[indice] }
      this.showDialogParam = true
    }
  }
}
</script>
